// --- TrustIndicator.tsx ---
import React from "react";

interface TrustIndicatorProps {
  confidence: number;
}

export const TrustIndicator: React.FC<TrustIndicatorProps> = ({ confidence }) => {
  const config = {
    high: { color: "#00e676", icon: "🟢", label: "AI OK", min: 80 },
    mixed: { color: "#ffc107", icon: "🟡", label: "MIXED", min: 50 },
    low: { color: "#ff3b3b", icon: "🔴", label: "FALLBACK", min: 0 }
  };
  
  const status = confidence >= config.high.min ? config.high :
                 confidence >= config.mixed.min ? config.mixed : config.low;

  return (
    <div 
      className="flex items-center gap-2 font-mono text-xs uppercase"
      style={{ color: status.color }}
      role="status"
      aria-label={`Poziom zaufania do analizy: ${status.label} ${confidence}%`}
    >
      <span aria-hidden="true">{status.icon}</span>
      <span>{status.label} · {confidence}%</span>
    </div>
  );
};
